import { render, staticRenderFns } from "./weightRepInput.vue?vue&type=template&id=03bf9108&scoped=true"
import script from "./weightRepInput.vue?vue&type=script&lang=js"
export * from "./weightRepInput.vue?vue&type=script&lang=js"
import style0 from "./weightRepInput.vue?vue&type=style&index=0&id=03bf9108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bf9108",
  null
  
)

export default component.exports